import React from 'react';
import Styles from "./styles.module.scss";
import ellowLogo from "../../assets/images/ellow-logo.svg";
import pageGraphics from "../../assets/images/pageGraphics.svg"

function FallbackPage() {
  
  return (

    <section className={Styles.verifiWrapper}>
        <div className={Styles.header}>
            <img src={ellowLogo} alt="ellow.io" />
        </div>
        <div className={Styles.errorMessage}> 
            <img src={pageGraphics} alt=''/>
            <h1>Sorry the page you are looking for does not exist.</h1>
            <p>In case of any queries , Please reach out to us at <br></br><a href="mailti:team@ellow.io" className={Styles.link}>team@ellow.io</a></p>
        </div>
    </section>
  )
}

export default FallbackPage